import { Injectable } from '@angular/core';
import { ComponentStore, tapResponse } from '@ngrx/component-store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, switchMap, tap, withLatestFrom } from 'rxjs';
import { NotificationsService } from 'src/app/core/services/notifications.service';
import {
    CityMap,
  CompanyAdditionalInfo,
  CompanyDetailsDTO,
  CompanyMainInfo,
} from '../models/company';
import { CompanyService } from './company.service';

export interface CompanyState extends CompanyDetailsDTO {}

@Injectable({ providedIn: 'root' })
export class CompanyStore extends ComponentStore<CompanyState> {
  private messages: any;

  constructor(
    private service: CompanyService,
    private notifs: NotificationsService,
    private translate: TranslateService
  ) {
    super(undefined);
    this.messages = this.translate.instant('SUCCESS_MESSAGE.COMPANY');
  }

  readonly mainInfo$ = this.select((state) => state.mainInfo);
  readonly additionalInfo$ = this.select((state) => state.additionalInfo);
  readonly contacts$ = this.select((state) => state.companyContacts);
  readonly offices$ = this.select((state) => state.companyOffices);
  readonly accountManagers$ = this.select(
    (state) => state.companyAccountManagers?.workers
  );
  readonly companyId$ = this.select((state) => state.id);

  private readonly setCompanyDetails = this.updater(
    (state: CompanyState, newData: CompanyDetailsDTO) => {
      const res = {
        ...state,
        mainInfo: { ...newData.mainInfo },
        additionalInfo: { ...newData.additionalInfo },
        companyAccountManagers: { ...newData.companyAccountManagers },
        companyContacts: { ...newData.companyContacts },
        companyOffices: { ...newData.companyOffices! },
      };
      console.log(state, newData);
      return res;
    }
  );

  readonly onLoadCompanyDetails = () => this.effect(() => {
    return this.service.getCompany().pipe(
      tap(console.log),
      tap((company: any) => this.setState(company))
    );
  })

  readonly getCompanyDetails = (bulstat: string = '') => {
    return this.service.getCompany(bulstat).pipe(
      tap(console.log),
      tap((company: any) => this.setState(company))
    );
  };

  getMapByCityId = (cityId: number): Observable<CityMap> => {
    return this.service.getCityMap<CityMap>(cityId)
      .pipe();
  }

  readonly updateCompanyAdditionalInfo = (data: {
    additionalInfo: Partial<CompanyAdditionalInfo>;
  }) => {
    return this.updateCompanyDetails(data);
  };

  readonly updateCompanyMainInfo = (data: { mainInfo: CompanyMainInfo }) => {
    return this.updateCompanyDetails(data);
  };

  private updateCompanyDetails = this.effect(
    (data$: Observable<Partial<CompanyDetailsDTO>>) => {
      return data$.pipe(
        withLatestFrom(this.companyId$, this.state$),
        switchMap(([data, companyId, state]) => {
          // const updated = updateChanged(state, data);
          return this.service.updateCompany({ ...data, id: companyId }).pipe(
            switchMap(() => this.service.getCompany()),
            tapResponse(
              (res) => {
                this.setCompanyDetails(res);
                this.notifs.success(this.messages['EDIT']);
              },
              (err) => this.onError(err)
            )
          );
        })
      );
    }
  );

  private onError(err: any) {}
}
